import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["cached", "always", "alwaysWrapper"]

  connect() {
    this.sync()
  }

  sync() {
    const materialized = this.cachedTarget.checked

    if (materialized) this.alwaysTarget.checked = false
    this.alwaysTarget.disabled = materialized
    this.alwaysWrapperTarget.classList.toggle("opacity-50", materialized)
    this.alwaysWrapperTarget.classList.toggle("cursor-not-allowed", materialized)
  }
}
